// Centralized social links. Replace URLs as needed.
export const SOCIAL_LINKS = [
  { name: 'Twitter', key: 'twitter', url: 'https://twitter.com/40_bags' },
  { name: 'YouTube', key: 'youtube', url: 'https://youtube.com/@40Bags' },
  { name: 'Instagram', key: 'instagram', url: 'https://instagram.com/forty_bags_entertainment' },
  { name: 'Facebook', key: 'facebook', url: 'https://facebook.com/61554182584759' },
];

export default SOCIAL_LINKS;


